export default "__VITE_ASSET__f82dc985__"